import ReadingCard from './ReadingCard';

export default ReadingCard;
